'use client';

import { CheckableElementProps } from '@/interfaces/basicForm';
import { checkedValue } from '@/utils/helper';
import { useEffect, useState } from 'react';

export const SizeCheckbox = ({ name, value, label, className = '', selectedValues, onChange }: CheckableElementProps) => {
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    setChecked(checkedValue(selectedValues, value));
  }, [selectedValues, value]);

  return (
    <label
      className={`checkbox size-checkbox cursor-pointer flex-col rounded-[5px] border border-[#e5e5e5] hover:border-black ${
        checked ? 'checked bg-black text-white' : 'bg-transparent'
      } ${className}`}
    >
      <input
        type="checkbox"
        className="hidden"
        checked={checked}
        {...{ name, value }}
        onChange={(e) => {
          if (checked) {
            setChecked(false);
          } else {
            setChecked(true);
          }
          onChange?.();
        }}
      />
      <span className="m-auto">{label}</span>
    </label>
  );
};
